var global = require('../internals/global');
var setGlobal = require('../internals/set-global');

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/shared-store.js
// module id = 794
// module chunks = 1